






















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'SearchBanner'
})
export default class SearchBanner extends Vue {
  @Prop({ required: true }) readonly action!: string

  submit(): void {
    (this.$refs.form as HTMLFormElement).submit()
  }
}
